import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate, Outlet } from 'react-router-dom';

const PrivateRoute = () => {

  const { user } = useSelector((state) => state.admin);

  // ✅ check token inside user
  return user && user.token ? <Outlet /> : <Navigate to="/login" replace />;
};

export default PrivateRoute;